import partial from 'lodash/partial'
import {segment} from './helpers'

// TODO: Remove this as part of https://theblacktux.atlassian.net/browse/TECH-1090
export const clickedShowroomsAccordion = partial(segment, 'Clicked Accordion')

/**
 * Fired when we want to know if a user saw a TBT promoted showroom in the search results
 *
 * @param {boolean} hasTbtPromotedShowroom If the page has a TBT promoted showroom
 */
export const viewedTbtPromotedSearchResult = (hasTbtPromotedShowroom) =>
  segment(`TBT Promoted Spot, ${hasTbtPromotedShowroom}`, {
    location: 'Search results page',
  })

/**
 * Fired when the user submits a search query via the showroom search bar
 *
 * @param {Object} searchQueryParams          Showroom search query params object
 * @param {number} searchQueryParams.distance Selected search radius distance to query for
 * @param {number} searchQueryParams.zipCode  Input ZIP code address to query for
 */
export const searchedShowroom = ({distance, zipCode}) => {
  segment('Searched Showroom', {distance, zipCode})
}

/**
 * Fired when the user views the showroom search error
 *
 */
export const viewedShowroomSearchError = partial(segment, 'Viewed Showroom Search Error', {
  error: 'Invalid zip input',
})
